import React from 'react';
import { Building, Globe2, MapPin } from 'lucide-react';
import { useSite } from '../context/SiteContext';

const iconMap = { Building, Globe2, MapPin };

const About = () => {
  const { about } = useSite();
  if (!about) return null;
  return (
    <section id="about" className="section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <p className="text-xs uppercase tracking-[0.24em] text-brand-green-light">{about.eyebrow}</p>
            <h2 className="mt-4 text-3xl md:text-4xl font-bold text-white leading-tight">
              {about.heading}
            </h2>
            {about.paragraphs.map((p, i) => (
              <p key={i} className="mt-5 text-slate-400 leading-relaxed">{p}</p>
            ))}

            <div className="mt-8 grid sm:grid-cols-3 gap-4">
              {about.facts.map((f) => {
                const Icon = iconMap[f.icon] || Building;
                return (
                  <div key={f.k} className="glass rounded-xl p-4">
                    <Icon className="h-5 w-5 text-brand-green-light" />
                    <div className="mt-3 text-xs text-slate-400 uppercase tracking-widest">{f.k}</div>
                    <div className="text-white font-semibold mt-1">{f.v}</div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="relative">
              <div className="absolute -inset-4 rounded-3xl bg-brand-green/10 blur-3xl" />
              <div className="relative rounded-2xl overflow-hidden glass-strong">
                <img
                  src={about.image}
                  alt="Recreasol outlet"
                  className="w-full h-72 md:h-96 object-cover"
                />
                <div
                  aria-hidden
                  className="absolute inset-0"
                  style={{
                    background:
                      'linear-gradient(180deg, rgba(6,8,13,0) 40%, rgba(6,8,13,0.85) 100%)',
                  }}
                />
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <p className="text-xs uppercase tracking-widest text-brand-pink-light">{about.missionEyebrow}</p>
                  <p className="mt-2 text-white text-lg font-medium max-w-xl">{about.missionText}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
